/* Mauna — small progressive enhancements. No dependencies. */
(function () {
  'use strict';

  /* ----------------------------------------------------------
     1. Estimated delivery window — product pages only.

     Real supplier figures (Teemdrop, YUN-Fast-Electro line):
       processing  1-3 days for 80% of orders
       transit     5-8 days
     => 6 to 11 days. Mauna publishes a 6-10 day window, which is
        the maximum the store is willing to promise.
     ---------------------------------------------------------- */
  var ETA_MIN = 6;
  var ETA_MAX = 10;

  function addDays(from, days) {
    var d = new Date(from.getTime());
    d.setDate(d.getDate() + days);
    return d;
  }

  function fmt(d) {
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  }

  function isProductPage() {
    var main = document.querySelector('main[data-template]');
    if (!main) return false;
    return main.getAttribute('data-template').indexOf('product') === 0;
  }

  function renderEta() {
    if (!isProductPage()) return;
    var lists = document.querySelectorAll('.mnp-trust');
    if (!lists.length) return;
    var now = new Date();
    var early = fmt(addDays(now, ETA_MIN));
    var late = fmt(addDays(now, ETA_MAX));

    lists.forEach(function (list) {
      if (list.querySelector('.mnp-eta')) return;
      var li = document.createElement('li');
      li.className = 'mnp-eta';
      var b = document.createElement('b');
      b.textContent = 'Order today, arrives between ' + early + ' and ' + late;
      var s = document.createElement('span');
      s.textContent = 'Standard shipping to any address in the contiguous United States.';
      li.appendChild(b);
      li.appendChild(s);
      list.insertBefore(li, list.firstElementChild);
    });
  }

  /* ----------------------------------------------------------
     2. Open the cart after something is added.

     The theme confirms an add with a checkmark on the button and
     nothing else. That leaves the whole cart layer — the free
     gift line, the trust row and the Glow Duo swap — behind a
     click almost nobody makes. Adding to a cart is the moment the
     cross-sell is worth showing, so the drawer opens itself.
     ---------------------------------------------------------- */
  var suppressDrawer = false;

  function openCartDrawer() {
    if (suppressDrawer) return;
    var drawer = document.getElementById('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      try {
        drawer.open();
        return;
      } catch (e) {
        /* fall through to the button */
      }
    }
    var toggle = document.querySelector('[aria-controls="cart-drawer"]');
    if (toggle) toggle.click();
  }

  if (!window.__maunaCartHook) {
    window.__maunaCartHook = true;
    var nativeFetch = window.fetch;

    window.fetch = function (input, init) {
      var url = '';
      if (typeof input === 'string') {
        url = input;
      } else if (input && typeof input.url === 'string') {
        url = input.url;
      }

      var request = nativeFetch.apply(this, arguments);

      if (url.indexOf('/cart/add') !== -1) {
        request
          .then(function (response) {
            if (!response || !response.ok) return;
            window.setTimeout(openCartDrawer, 400);
          })
          .catch(function () {});
      }

      return request;
    };
  }

  /* ----------------------------------------------------------
     3. Cart: swap one half of the Duo for the Duo itself.
     ---------------------------------------------------------- */
  function post(url, payload) {
    return window.fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) throw new Error(url + ' ' + r.status);
      return r.json();
    });
  }

  document.addEventListener('click', function (e) {
    var target = e.target instanceof Element ? e.target.closest('[data-mna-swap]') : null;
    if (!target) return;

    var removeKey = target.getAttribute('data-remove');
    var addId = target.getAttribute('data-add');
    if (!removeKey || !addId) return;

    e.preventDefault();
    target.setAttribute('aria-busy', 'true');
    suppressDrawer = true;

    post('/cart/add.js', { items: [{ id: Number(addId), quantity: 1 }] })
      .then(function () {
        return post('/cart/change.js', { id: removeKey, quantity: 0 });
      })
      .then(function () {
        window.location.href = '/cart';
      })
      .catch(function () {
        suppressDrawer = false;
        window.location.href = target.getAttribute('href') || '/products/glow-duo';
      });
  });

  /* ----------------------------------------------------------
     4. Recently viewed. Stored in this browser only; never sent
        anywhere. Renders into [data-mna-recent].

     El alt de cada miniatura es el nombre del producto. Estaba
     vacio y era el unico alt vacio que quedaba en la tienda.
     ---------------------------------------------------------- */
  var RV_KEY = 'mauna:recent';

  function readRecent() {
    try { return JSON.parse(window.localStorage.getItem(RV_KEY)) || []; }
    catch (e) { return []; }
  }

  function writeRecent(list) {
    try { window.localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, 8))); }
    catch (e) { /* private mode, blocked storage: nothing to do */ }
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function recentlyViewed() {
    var host = document.querySelector('[data-mna-recent]');
    var current = host ? host.getAttribute('data-current') : null;
    var list = readRecent();

    if (current) {
      list = list.filter(function (h) { return h !== current; });
      list.unshift(current);
      writeRecent(list);
    }
    if (!host) return;

    var show = list.filter(function (h) { return h !== current; }).slice(0, 4);
    if (!show.length) return;

    Promise.all(show.map(function (h) {
      return window.fetch('/products/' + encodeURIComponent(h) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (items) {
      items = items.filter(Boolean);
      if (!items.length) return;

      var html = '<h3 class="mnrv-h">You looked at these</h3><ul class="mnrv-list">';
      items.forEach(function (p) {
        var img = p.featured_image || (p.images && p.images[0]) || '';
        var price = (p.price / 100).toFixed(2);
        html += '<li class="mnrv-item"><a href="/products/' + esc(p.handle) + '">'
          + '<span class="mnrv-art">'
          + (img ? '<img src="' + esc(img) + '&width=500" alt="' + esc(p.title) + '" loading="lazy">' : '')
          + '</span>'
          + '<span class="mnrv-t">' + esc(p.title) + '</span>'
          + '<span class="mnrv-p">$' + esc(price) + '</span>'
          + '</a></li>';
      });
      html += '</ul>';
      host.innerHTML = html;
      host.hidden = false;
    });
  }

  /* ---------------------------------------------------------- */
  function boot() {
    renderEta();
    recentlyViewed();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(function () {
      pending = false;
      renderEta();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
